// extracted by mini-css-extract-plugin
export default {"imagebg":"home_imagebg__XgrNg"};